import './ManualAccordion.scss'
import { CHEVRON_DOWN_RIVER_BLUE } from '../../../assets/images'
import { getImageSrc } from '../../../utils/local-util'
import { Accordion } from '../../shared/ReactBootstrap'

const ManualAccordion = ({
  accordionIcon = CHEVRON_DOWN_RIVER_BLUE,
  alwaysOpen = false,
  childComponents,
  cqItems,
  cqItemsOrder = [],
  defaultActiveKey = []
}: any): JSX.Element => {
  const handleAccordionNavClick = (itemKey: string) => {
    const isActive = defaultActiveKey.indexOf(itemKey) > -1
    const expandedItems = defaultActiveKey

    if (isActive) {
      const index = defaultActiveKey.indexOf(itemKey)
      expandedItems.splice(index)
    } else {
      expandedItems.push(itemKey)
    }
  }

  return (
    <Accordion className={`react-accordion`} alwaysOpen={alwaysOpen} defaultActiveKey={defaultActiveKey} flush>
      {cqItemsOrder.map((key: any) => {
        const item = cqItems[key] as any
        const itemContentIndex = cqItemsOrder.indexOf(key)
        return (
          <Accordion.Item eventKey={`${key}`} key={`${key}-item`}>
            <Accordion.Header
              as={'h3'}
              key={`${key}-header`}
              onClick={() => {
                handleAccordionNavClick(key)
              }}
            >
              <a role='button'>
                <div className='accordion-title'>{item['cq:panelTitle'] as any}</div>
              </a>
              <div className='accordion-chevron' style={{ background: `url("${getImageSrc(accordionIcon)}")` }}></div>
            </Accordion.Header>
            <div className='accordion-item-container'>
              <Accordion.Body>{childComponents[itemContentIndex]}</Accordion.Body>
              <div className='divider'></div>
            </div>
          </Accordion.Item>
        )
      })}
    </Accordion>
  )
}

export default ManualAccordion
